<template>
  <div class="wrapper">
    <div class="fundDoc"  @click="fundDocACtion" v-if="!isTs">
      <span class="fundDoctext">诊断</span>
    </div>
    <div class="header">
      <!-- 基金名 -->
      <FundNameView :name="basicInfo.fundName" :code="basicInfo.fundCode" />
      <!-- 基金名下标签描述 -->
      <div class="header-tags">
        <!-- 基金代码 -->
        <span class="pgnextCode">
          {{basicInfo.fundCode}}
        </span>
        <!-- 后端标签 -->
        <span class="hdnexcodeview" v-if="!isEmpty(basicInfo.backCode)"
          :style="{'background-image': 'linear-gradient(90deg, #ffffff 0%, #e0e0e0 64%)'}"
          >后端
          <span class="hdnexcode">{{basicInfo.backCode}}</span>
        </span>
        <!-- web无持仓逻辑 -->
        <span class="tag-text"
         v-if="isqdHold || ishdHold" @click="tradeDetailJump" >查看持仓</span>
        <!-- 标签 -->
        <span class="tag-text" v-for="(item, index) in fundDetail1.headerTags"
        :key="`tag-${index}`" @click="clickTipView(item)"> {{item.tag}} </span>
        <!-- ↓新接口应该不需要了 -->
        <!-- <span class="tag-text"
         v-if="GradeEName !== '--'" @click="clickGradeEName" >{{GradeEName}}</span>
        <span class="tag-text"
         v-if="TTYPEName !== '--'" @click="clickTTYPE" >{{TTYPEName}}</span>
        <span class="tag-text"
        v-for="(item, index) in getshowAltModule(baseConfigInfo,tagInfo)"
        :key="index" @click="showFundOth(item)"> {{item.LableName}} </span> -->
        <!-- TODO ETF标签 -->
      </div>
      <!-- 行情信息 替换组件 -->
      <!-- <div class="market" v-if="!isGradeBondAFund && !isTs">
        <div class="rigrht-center-view" @click="clickMarket">
          <div class="panel panel-2">
            <span class="text">
              <span class="text-r"
              :style="{ color: getValueColor(pageData.rightValue)}" >{{pageData.rightValue}}</span>
              <span class="market-unit" v-if="pageData.rightValue !== '--'"
              :style="{ color: getValueColor(pageData.rightValue)}">%</span>
            </span>
            <span class="labelllll">{{pageData.rightTitle}}</span>
          </div>
        </div>
        <div class="pgleftView" v-if="!isMonetaryfund">
          <div class="panel" @click="clickMarket">
            <span class="textrrrr">{{pageData.leftValue}}</span>
            <span class="label">净值</span>
          </div>
          <div class="panel" >
            <span class="textrrrr"
            :style="{ color: getValueColor(pageData.syl1n)}"
            @click="clickjszf">{{pageData.syl1nPer}}</span>
            <span class="label" v-if="pageData.shojszftip === '成立来'"
            @click="clickjszfcll">{{pageData.shojszftip}}
              <img class="warn-tip-gray-gx"
                src='@/assets/warn-tip-gray.png' /></span>
                <span class="label" @click="clickjszf" v-else>{{pageData.shojszftip}}</span>
          </div>
        </div>
        <div class="panel" v-if="isMonetaryfund">
          <span class="texthb">{{pageData.leftValue}}</span>
          <span class="labelhb">{{pageData.leftTitle}}</span>
        </div>
      </div> -->
      <normal-market-header :basic-info="basicInfo" />
      <!-- from 杨永智：小程序里没有了 -->
      <!-- <div class="market market-grade-A"
      v-if="isGradeBondAFund && !isTs" @click="clickMarket">
        <div class="panel">
          <div class="flex-row">
            <span class="label">最近约定年化收益率</span>
            <img class="tip-icon" @click="showTips" src="../assets/warn-tip-gray.png" />
          </div>
          <span class="text">
            {{pageData.OPEYIELD}}
            <span class="market-unit" v-if="pageData.OPEYIELD !== '--'">%</span>
          </span>
        </div>
        <div class="rigrht-center-view">
          <div class="panel panel-2">
            <span class="label">封闭期</span>
            <span class="text">{{pageData.CYCLE}}</span>
          </div>
        </div>
      </div> -->

      <!-- 大数据榜单入口 -->
      <!-- <div
        @click="toBigDataList"
        v-if="bigDataListInfo.BUSINESSTEXT && pageType === 'normal'"
        class="big-data-list"
      >
        <image :style="{opacity: opacity}" class="big-data-bg" src='https://j5.dfcfw.com/sc/image/202209/20220908070100.png'/>
        <image class="big-data-img" src='https://j5.dfcfw.com/sc/image/202209/20220905070324.png'/>
        <text :style="{color: color}" class="big-data-text">{{bigDataListInfo.BUSINESSTEXT}}</text>
        <image class="big-data-arrow" :src='arrow'/>
      </div> -->
      <div class="market" v-if="isTs">
        <div class="header-ts">
          <span class="stop-hsale-label">已于{{pageData.TSRQ}}退市</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// eslint-disable-next-line no-unused-vars
import BScroll from 'better-scroll';

import StoreManger from '@/utils/FundHQJHManger';
import JS from '@/base/JSTool';
import FundTypeSearch from '@/utils/FundTypeSearch';
import { mapGetters, mapState } from 'vuex';

// import { setStorage } from '@fund/storage';
import FundNameView from '@/components/Fund-FundNameVIew.vue';
import coverw from '@/assets/head-cover-w.png';
import NativeMsg from '@/base/NativeMsg';
import aw from '@/assets/QT-009-2.png';
import ag from '@/assets/QT-009.png';
import {
  userLogin,
  detailPushPage,
} from '@/utils/nativeBridge';
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
import NormalMarketHeader from './FundHeaderMarket/NormalMarketHeader.vue';
// eslint-disable-next-line import/no-extraneous-dependencies
// import BScroll from 'better-scroll';

export default {
  name: 'WarningeeTip',
  props: {
    basicInfo: {
      type: Object,
    },
  },
  components: {
    FundNameView,
    NormalMarketHeader,
  },
  data() {
    return {
      fundCode: '',
      hdfundCode: '--',
      fundName: '',
      fundType: '',
      headerClass: 'header-white',
      headercovr: '',
      aimge: '',
      pageData: {},
      showSpview: false,
      showANdroid: true,
      showwap: false,
      tagInfo: {},
      tagsList: [],
      TTYPEName: '--',
      GradeEName: '--',
      isHold: false,
      ishdHold: false,
      isqdHold: false,
      confgListALert: [],
      hdcode: '',
      isIOS: false,
      holdzhALertLsit: [],
      holdData: null,
    };
  },
  computed: {
    ...mapState('detail1', ['fundDetail1']),
    isTs() { // 是否退市
      return this.basicInfo?.isDelListedFund;
    },
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
    isGradeBondAFund() {
      return FundTypeSearch.isGradeBondAFund(this.fundType);
    },
    ...mapGetters({
      baseConfigInfo: 'currentADConDate',
    }),
  },
  watch: {
    fundDetail1() {
      console.log('===> watch vuex data change', this.fundDetail1);
    },
  },
  created() {
    this.loadHeadView();
    NativeMsg.reg('reloadUserProfit', () => {
      this.configureHoldData();
    });
  },
  mounted() {
    console.log('===> data from vuex', this.fundDetail1);
  },
  methods: {
    isEmpty,
    configureHoldData() {
      const baseInfo = StoreManger.getFundJJXQ();
      this.hdcode = baseInfo.BACKCODE;
      const qdcode = baseInfo.FCODE;
      const data = StoreManger.GetFundsProductProfit();
      console.log('head --- configureHoldData');
      console.log(JSON.stringify(data));
      if (data) {
        if (data.Data) {
          data.Data.forEach((element) => {
            if (element.FundCode === qdcode) {
              if (element.IsHolding) {
                this.isqdHold = true;
              }
            }
            if (element.FundCode === this.hdcode) {
              if (element.IsHolding) {
                this.ishdHold = true;
              }
            }
          });
        }
      }
      this.confgListALertData();
    },
    confgListALertData() {
      const list = [];
      if (this.isqdHold) {
        //  前段
        list.push({
          title: `前端:${this.fundCode}`,
          code: this.fundCode,
        });
      }
      if (this.ishdHold) {
        // 后端
        list.push({
          title: `后端:${this.hdcode}`,
          code: this.hdcode,
        });
      }
      this.confgListALert = list;
      console.log(this.confgListALert);
    },
    clickHoldFund() {
      if (this.confgListALert.length === 1) {
        this.showHoldDetail(this.confgListALert[0].code);
      } else if (this.confgListALert.length > 1) {
        const itemList = [];
        const itemColor = [];
        // eslint-disable-next-line array-callback-return
        this.confgListALert.map((data) => {
          itemList.push(data.title);
          itemColor.push('#000000');
        });
        this.$feedback.showActionSheet({
          itemList,
          itemColor,
          cancelText: '取消',
          cancelColor: '#000000',
          success: ({ tapIndex }) => {
            const item = this.confgListALert[tapIndex];
            this.showHoldDetail(item.code);
            if (tapIndex === 0) {
              this.reportMonitor({
                eventName: 'pz.tbkp.qhdccqd.click',
              });
            } else {
              this.reportMonitor({
                eventName: 'pz.tbkp.qhdcchd.click',
              });
            }
          },
          fail() {
          },
        });
      }
    },
    contentListView() {
      const baseInfo = StoreManger.getFundJJXQ();
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      const BAGTYPE = JS.fetchString(baseInfo, 'BAGTYPE');
      let tiplist = [
        {
          LableName: this.pageData.FTYPE,
          eventName: 'pz.top.type',
          Link: {
            LinkType: '2',
            LinkTo: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${code}`,
          },
        },
      ];
      if (BAGTYPE === '1') {
        tiplist = [
          {
            LableName: '活期宝',
            eventName: 'pz.top.type',
            Link: {
              LinkType: '2',
              LinkTo: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${code}`,
            },
          },
        ];
      }
      if (this.pageData.riskLevel !== '--') {
        tiplist.push({
          LableName: this.pageData.riskLevel,
          eventName: 'pz.top.risk',
          Link: {
            LinkType: '2',
            LinkTo: `fund://mp.1234567.com.cn/weex/b34ccfc4ed9a4af4a4880fee485cf417/pages/FundDetailInfo?FCODE=${code}`,
          },
        });
      }
      if (this.pageData.fundGrade === '上证五星评级') {
        this.GradeEName = this.pageData.fundGrade;
      }
      if (this.pageData.TTYPENAME !== '--') {
        this.TTYPEName = this.pageData.TTYPENAME;
      }
      this.tagsList = tiplist;
    },
    // 评级
    clickGradeEName() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      const subUrl = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundStageIncrease?fundCode=${code}&fundName=${name}&pagetype=3`;
      detailPushPage({
        type: '2',
        url: subUrl,
      });
      this.reportMonitor({
        eventName: 'pz.tbkp.szpjbq.click',
      });
    },
    // 主题
    clickTTYPE() {
      const baseInfo = StoreManger.getFundJJXQ();
      const { FBKINDEXCODE } = baseInfo;
      const subUrl = `fund://mp.1234567.com.cn/weex/96ca73cc162c078b2d758415d49b58e8/pages/HotPlateDetailPage?bkcode=${FBKINDEXCODE}`;
      detailPushPage({
        type: '2',
        url: subUrl,
      });
      this.reportMonitor({
        eventName: 'pz.tbkp.jjzt.click',
      });
    },
    clickTipView(item) {
      const { LinkType, LinkTo } = item.Link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      this.reportMonitor({
        eventName: item.eventName,
      });
    },
    loadHeadView() {
      this.configureFund();
      this.handleData();
      // #if EXECUTION_ENV === 'fund'
      // eslint-disable-next-line no-undef
      const systemInfo = fund.getSystemInfoSync();
      console.log(JSON.stringify(systemInfo));
      if (systemInfo) {
        if (systemInfo.system) {
          if (systemInfo.system.indexOf) {
            if (systemInfo.system.indexOf('iOS') !== -1) {
              this.showANdroid = false;
              this.isIOS = true;
            }
          }
        }
      }
      // #endif
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      this.isIOS = true;
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wxmp' || webPlatf === 'wap' || webPlatf === 'wx') {
        this.showANdroid = false;
      }
      if (webPlatf === 'wap' || webPlatf === 'quick' || webPlatf === 'wx') {
        this.showwap = true;
      }
      // #endif
    },
    width() {
      const wrap1 = this.$refs.li1.children;
      let sum = 0;
      for (let i = 0; i < wrap1.length; i += 1) {
        sum += wrap1[i].offsetWidth;
      }
      return sum + wrap1.length * 16 * 2;
    },
    clickjszfcll() {
      this.$feedback.showToast({ title: '该基金成立不满1年', duration: 3000 });
    },
    clickjszf() {
      const baseInfo = StoreManger.getFundJJXQ();
      if (!baseInfo) {
        return;
      }
      if (!baseInfo.SHORTNAME) {
        return;
      }
      detailPushPage({
        appId: '516939c37bdb4ba2b1138c50cf69a2e1',
        url: '/pages/FundStageIncrease',
        params: {
          fundCode: this.fundCode,
          fundName: baseInfo.SHORTNAME,
          isHuobi: 0,
        },
      });
      this.reportMonitor({
        eventName: 'pz.tbkp.jdzf.click',
      });
    },
    clickMarket() {
      const isGradeBondAFund = FundTypeSearch.isGradeBondAFund(this.fundType);
      if (!isGradeBondAFund) {
        const isMoney = FundTypeSearch.isMonetaryfund(this.fundType);
        const baseInfo = StoreManger.getFundJJXQ();
        const name = StoreManger.getFundJJXQNAME(baseInfo);
        const code = StoreManger.getFundJJXQCODE(baseInfo);
        let url = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryNetWorth?fundCode=${code}&fundName=${name}`;
        if (isMoney) {
          url = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryIncome?fundCode=${code}&fundName=${name}&featuretype=${baseInfo.FEATURE}`;
        }
        detailPushPage({
          type: 2,
          url,
        });
      } else {
        const baseInfo = StoreManger.getFundJJXQ();
        const name = StoreManger.getFundJJXQNAME(baseInfo);
        const code = StoreManger.getFundJJXQCODE(baseInfo);
        const url = `fund://mp.1234567.com.cn/weex/516939c37bdb4ba2b1138c50cf69a2e1/pages/FundHistoryNetWorth?fundCode=${code}&fundName=${name}`;
        detailPushPage({
          type: 2,
          url,
        });
      }
      this.reportMonitor({
        eventName: 'pz.top.jz',
      });
    },
    render() {
      this.configureFund();
      this.getHoldFundList();
      this.tagInfo = StoreManger.getFundJJBQ();
      this.contentListView();
      const endDate = new Date(this.pageData.TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      if (serverDate > endDate) {
        // this.isTs = true;
      }
    },
    getHoldFundList() {
    },
    getHoldState() {
    },
    showholdSubAlert() {
      const itemList = [];
      const itemColor = [];
      this.$feedback.showActionSheet({
        itemList,
        itemColor,
        cancelText: '取消',
        cancelColor: '#000000',
        success: ({ tapIndex }) => {
          console.log(tapIndex);
        },
        fail(res) {
          console.log(res);
        },
      });
    },
    tradeDetailJump() {
      userLogin().then(() => {
        this.clickHoldFund();
      }).catch(() => {

      });
    },
    showHoldDetail(code) {
      let ishqb = '0';
      const fundData = StoreManger.getFundJJXQ();
      const BAGTYPE = JS.fetchString(fundData, 'BAGTYPE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (ishqb === '1') {
        detailPushPage({
          type: 2,
          url: 'fund://mp.1234567.com.cn/weex/8dc73ba44160494fb54b076d2a965751',
        });
      } else {
        detailPushPage({
          appId: '0b74fd40a63b40fb99467fedd9156d8f',
          url: '/pages/holdDetailPage',
          params: {
            fundCode: code,
            subAccountNo: '',
          },
        });
      }
      this.reportMonitor({
        eventName: 'pz.top.holdtag',
      });
    },
    configureFund() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;
      this.pageData = this.format(StoreManger.getFundJJXQ());
      const baseInfo = StoreManger.getFundJJXQ();
      if (baseInfo) {
        this.hdfundCode = baseInfo.BACKCODE;
      }
      console.log('configureFund fundCode fundType pageData');
      console.log(`${JSON.stringify(this.pageData)}`);
      this.handleData();
    },
    getshowAltModule(item) {
      const taglist = [];
      if (this.tagInfo && this.tagInfo.Datas) {
        for (let index = 0; index < this.tagInfo.Datas.length; index += 1) {
          const element = this.tagInfo.Datas[index];
          for (let y = 0; y < element.TAGLIST.length; y += 1) {
            const tagItam = element.TAGLIST[y];
            const url = `fund://mp.1234567.com.cn/weex/0c09decfcf0642ca9f2829adde894ee8/pages/FundForTagList?tagcode=${tagItam.FEAVALUE}&tagname=${tagItam.FEANAME}`;
            if (tagItam.FEANAME && tagItam.FEANAME !== '--' && tagItam.FEANAME !== '') {
              taglist.push({
                tag: '1',
                tid: tagItam.FEAVALUE,
                LableName: tagItam.FEANAME,
                Link: { LinkType: '2', AdId: '', LinkTo: url },
              });
            }
          }
        }
      }
      let index = 2;
      if (this.pageData.fundGrade === '上证五星评级') {
        index += 1;
      }
      if (this.pageData.TTYPENAME !== '--') {
        index += 1;
      }
      if (this.isHold) {
        index += 1;
      }
      let taglist2 = [];
      if (item) {
        const baseInfo = StoreManger.getFundJJXQ();
        if (baseInfo) {
          const { datas } = item;
          if (datas) {
            const { LableList } = datas;
            if (LableList) {
              taglist2 = LableList;
            }
          }
        }
      }
      const allList = taglist2.concat(taglist);
      const otherCount = 8 - index;
      const baseInfo = StoreManger.getFundJJXQ();
      if (allList && baseInfo) {
        if (allList.length > otherCount && otherCount > 0) {
          allList.splice(otherCount - 1, allList.length - otherCount + 1);
          if (allList.length > 4) {
            this.showSpview = true;
          }
          return allList;
        }
        if (allList.length > 4) {
          this.showSpview = true;
        }
        return allList;
      }
      return [];
    },
    handleData() {
      this.handleClass();
    },
    format(item) {
      // console.log('zxy --- format ----', `${JSON.stringify(item)}`);
      const fetch = (key) => {
        const res = JS.fetchString(item, key);
        return res || '--';
      };
      let syl1n = '--';
      let syl1nPer = '--';
      let shojszftip = '近1年';
      const tssjData = StoreManger.getFundTSSJ();
      if (tssjData) {
        if (tssjData.SYL_1N) {
          syl1n = tssjData.SYL_1N;
          if (syl1n !== '--') {
            syl1nPer = `${syl1n}%`;
          }
        }
      }
      if (syl1n === '--') {
        shojszftip = '成立来';
        if (tssjData) {
          if (tssjData.SYL_LN) {
            syl1n = tssjData.SYL_LN;
            if (syl1n !== '--') {
              syl1nPer = `${syl1n}%`;
            }
          }
        }
      }
      const RZDF = fetch('RZDF');
      this.fundName = fetch('SHORTNAME');
      const isMoney = this.isMonetaryfund;

      let FSRQ = fetch('FSRQ');
      FSRQ = FSRQ && FSRQ !== '--' ? FSRQ.slice(5) : '--';
      return {
        RZDF,
        leftTitle: (() => {
          const FEATURE = fetch('FEATURE');
          let unit = '万';
          if (FEATURE.indexOf('090') !== -1) {
            unit = '百万';
          } else if (FEATURE.indexOf('100') !== -1) {
            unit = '百';
          }
          unit = isMoney ? `万元收益 ${FSRQ}` : '最新净值';
          return `${unit}`;
        })(),
        shojszftip,
        syl1n,
        syl1nPer,
        leftValue: fetch('DWJZ'),
        rightTitle: isMoney ? '7日年化' : `日涨幅 ${FSRQ}`,
        rightValue: isMoney ? fetch('LJJZ') : RZDF,
        FIXINCOME: fetch('FIXINCOME'),
        OPEYIELD: fetch('OPEYIELD'),
        CYCLE: fetch('CYCLE'),
        TSRQ: fetch('TSRQ'),
        FTYPE: fetch('FTYPE'),
        riskLevel: (() => {
          const RISKLEVEL = fetch('RISKLEVEL');
          if (RISKLEVEL === '--' || !RISKLEVEL) {
            return '--';
          }
          // if (RISKLEVEL === '5') {
          //   return '高风险';
          // }
          // return '--';
          return RISKLEVEL === '--'
            ? '低风险'
            : `${['低', '中低', '中', '中高', '高'][RISKLEVEL - 1]}风险`;
        })(),
        fundGrade: (() => {
          const RLEVEL_SZ = fetch('RLEVEL_SZ');
          return RLEVEL_SZ === '--'
            ? ''
            : `上证${['一', '二', '三', '四', '五'][RLEVEL_SZ - 1]}星评级`;
        })(),
        TTYPENAME: fetch('FBKINDEXNAME'),
      };
    },
    handleClass() {
      NativeMsg.post(JSON.stringify({ key: 'refreshBarbtn', value: { v: 'start' } }));
      const endDate = new Date(this.pageData.TSRQ.replace(/-/g, '/')).getTime();
      const serverDate = new Date().getTime();
      this.aimge = aw;
      if (serverDate > endDate) {
        this.headerClass = 'header-white';
        this.headercovr = coverw;
        this.aimge = ag;
        return;
      }
      if (this.isGradeBondAFund) {
        this.headerClass = 'header-blue';
        this.headercovr = coverw;
        return;
      }
      if (this.isMonetaryfund) {
        if (this.pageData.rightValue === '--') {
          this.headerClass = 'header-white';
          this.aimge = ag;
          this.headercovr = coverw;
          return;
        }
        this.headerClass = 'header-red';
        this.headercovr = coverw;
        return;
      }
      if (!this.pageData.RZDF) {
        this.headerClass = 'header-white';
        this.aimge = ag;
        this.headercovr = '';
        return;
      }
      const RZDF = this.pageData.RZDF * 1;
      if (RZDF > 0) {
        this.headerClass = 'header-red';
        this.headercovr = coverw;
        return;
      }
      if (RZDF < 0) {
        this.headerClass = 'header-green';
        this.headercovr = coverw;
        return;
      }
      this.headerClass = 'header-white';
      this.aimge = ag;
      this.headercovr = coverw;
    },
    showTips() {
      const baseInfo = StoreManger.getFundJJXQ();
      this.$feedback.showModal({
        title: '约定利率规则',
        content: `约定年化收益率 = ${baseInfo.FIXINCOME}`,
        confirmText: '知道了',
        confirmColor: '#f40',
        showCancel: false,
      });
    },
    showFundOth(item) {
      const { LinkType, LinkTo } = item.Link;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
      if (item.tag && item.tag === '1') {
        this.reportMonitor({
          eventName: 'pz.top.specailtag',
          location: item.tid,
          eventContent: {
            location: item.tid,
          },
        });
      } else {
        this.reportMonitor({
          eventName: 'pz.tbkp.qmdbq.click',
          infoCodeType: '5',
          infoCode: this.fundCode,
        });
      }
    },
    fundDocACtion() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=${name}(${code})基金诊断`,
      });
      this.reportMonitor({
        eventName: 'pz.more.zd',
      });
      // 测试代码
      // 视频
      // window.localStorage.setItem(`videoshowtip${this.fundCode}`, '0');
      // // 头部
      // setStorage('ef-fund-newtopGui', '0');
      // // 天天
      // setStorage('ef-fund-newtopGuiTT', '0');
    },
    gotoDiagnosis() {
      detailPushPage({
        type: 2,
        url: `fund://mp.1234567.com.cn/weex/62e53625b3c74fbfabedc02c37824438/pages/diagnoseDetail?fundcode=${this.fundCode}`,
      });
    },
    getValueColor(value) {
      if (!value) {
        return '#000000';
      }
      if (value === '-') {
        return '#000000';
      }
      if (value === '--') {
        return '#000000';
      }
      if (value > 0) {
        return '#ff0000';
      }
      if (value < 0) {
        return '#12B412';
      }
      return '#000000';
    },
    getTypeName(item) {
      let ishqb = '0';
      const fundData = StoreManger.getFundJJXQ();
      const BAGTYPE = JS.fetchString(fundData, 'BAGTYPE');
      if (BAGTYPE === '1') {
        ishqb = '1';
      }
      if (ishqb === '1') {
        return '活期宝';
      }
      return item;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../global.less";
// @import "../../global.less";
.border-1px-gray {
  .border-1px(#eee);
}
.wrapper {
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
}
.red-22 {
  color: @app-color-up;
}
.header {

  border-radius: 10px;
  position: relative;
  padding-left: 24px;
  padding-right: 10px;
  background: #ffffff;
  color: #000;
}
.market {
  display: flex;
  flex-direction: row;
  padding: 20px 0 26px 0;
}

.market-grade-A {
  padding-bottom: 20px;
}
.pgleftView{
  display: flex;
  text-align: left;
  justify-content: flex-end;
  flex-direction: row;
  width: 55%;
}
.panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-end;
}
.rigrht-center-view{
  align-items: center;
  justify-content: center;
  width: 45%;
}
.panel-2 {
  text-align: left;
  justify-content: flex-end;
}

.panel-3 {
  align-items: center;
  justify-content: flex-end;
}
.labelhb {
  font-size: 26px;
  line-height: 26px;
  margin-bottom: 10px;
  color: #999999;
}
.label {
  font-size: 26px;
  line-height: 26px;
  margin-bottom: 10px;
  color: #999999;
}
.labelllll {
  font-size: 26px;
  line-height: 26px;
  margin-bottom: 10px;
  margin-left: -2px;
  color: #999999;
}

.texthb {
  font-family: DINAlternate-Bold;
  font-size: 72px;
  color: #000;
  margin-bottom: 10px;
}
.text {
  font-family: DINAlternate-Bold;
  font-size: 36px;
  color: #000;
  margin-bottom: 10px;
}
.text-r{
  font-family: DINAlternate-Bold;
  font-size: 72px;
  color: #000;
}
.textrrrr {
  font-family: DINAlternate-Bold;
  font-size: 36px;
  color: #000;
  margin-bottom: 13px;
}
.market-unit {
  font-family: DINAlternate-Bold;
  color: #000;
  font-size: 36px;
}

.wrapper-scrollView{
  white-space: nowrap;
}
.wrapper-content{
  display: inline-block;
}
.splin{
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-right: 20px;
}
.header-tags {
  // border-top: 1px solid rgba(255, 255, 255, 0.2);
  height: 60px;
  text-align: left;
  font-size: 24px;
  display:flex;
  flex-wrap: wrap;
  flex-direction:row;
  overflow:hidden;
  margin-top: 4px;
  margin-bottom: 6px;
}

.diagnose {
  background: #ffffff;
  border-radius: 100px 0 0 100px;

  font-size: 24px;
  color: #f24957;
  line-height: 24px;
  padding: 4px 30px;
}

.right-arrow {
  width: 17px;
  height: 17px;
  display: inline-block;
  border: 2px solid #fff;
  border-left: none;
  border-bottom: none;
  transform: rotate(45deg);
  position: relative;
  top: -30px;
}

.tag-text {
  margin-right: 8px;
  margin-top: 14px;
  margin-bottom: 4px;
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  color: #52a2ff;
  background-color: rgba(82, 162, 255, 0.1);
}

.diagnose {
  background: rgba(255, 100, 52, 0.36);
}
.splin{
  border-top: 1px solid #eeeeee;
  margin-right: 20px;
}
.right-arrow {
  border: 2px solid #ccc;
  border-left: none;
  border-bottom: none;
}
.tip-icon {
  height: 24px;
  width: 24px;
  margin-left: 10px;
}
.flex-row {
  display: flex;
  flex-direction: row;
}

.fundDoc {
  z-index: 99;
  width: 106px;
  height: 40px;
  background: rgba(0, 138, 255, 0.1);
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: absolute;
  margin-top: 38px;
  right: 24px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.fundDoctext{
  font-size: 24px;
  color: #008aff;
  line-height: 36px;
}
.stop-sale{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  border-bottom: 2px solid #eee;
}
.stop-sale-label{
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 36px;
  color: #999999;
}
.right-arrow-a{
  width: 30px;
  height: 30px;
  position: absolute;
  right: 24px;
  z-index: 99;
  align-items: center;
  display: flex;
  margin-top: 100px;
}

.right-arrow-v{
  width: 30px;
  height: 30px;
}
.box {
  height: 84px;
  display: flex;
  align-items: center;
}
.tag-textnew {
  color: #52a2ff;
  background: rgba(82, 162, 255, 0.1);
  text-align: center;
  border-radius: 4px;
  margin-right: 20px;
  padding: 8px 10px;
  font-size: 24px;
}
.warn-tip-gray-gx {
    width: 26px;
    vertical-align: middle;
    position: relative;
    top: -2px;
  }
.person-wrap {
  overflow: hidden;
  touch-action: none;
  height: 46px;
  .person-list {
    list-style-type: none;
    .person-item {
      float: left;
      margin: 0 16px;
      white-space: nowrap;
    }
    .current {
    }
  }
}

.header-ts {
  border-radius: 10px;
  position: relative;
  padding-left: 10px;
  padding-right: 24px;
  background: #ffffff;
  color: #000;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stop-hsale-label{
  font-family: DINAlternate-Bold;
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 36px;
  color: #999999;
}
.pgnextCode{
  margin-right: 8px;
  margin-top: 14px;
  margin-bottom: 4px;
  display: flex;
  border-radius: 4px;
  font-family: PingFangSC-Regular;
  font-size: 24px;
  letter-spacing: 0;
  padding-left:8px;
  padding-right:8px;
  line-height: normal;
  align-items: center;
  justify-content: center;
  color: #999999;
}
.hdnexcodeview{
  color: #999999;
  font-size: 24px;
  margin-top: 16px;
  margin-bottom: 6px;
  margin-right: 8px;
  line-height: normal;
  border-radius: 4px;
}
.hdnexcode{
  color: #999999;
  font-size: 24px;
  margin-right: 8px;
  font-family: DINAlternate-Bold;
}
</style>
